const staffStaffScheduling = () =>
  import('@/views/main/staff/staff-scheduling/staff-scheduling.vue')
export default {
  path: '/main/staff/staffScheduling',
  name: 'staffStaffScheduling',
  component: staffStaffScheduling,
  children: []
}
